import { t } from '@lingui/core/macro';

import TooltipRow from '@/components/Flare/guides/TooltipRow';
import MultiSeriesTooltip from '@/components/MultiSeriesTooltip';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/Tooltip';
import { TAM_PRIMARY, VISITS_PRIMARY } from '@/constants/colors';
import { numberFormat } from '@/helper/numberFormatter';

type Props = {
  title: string;
  customerBenchmark?: number;
  industryBenchmark?: number;
  open: boolean;
};

const BenchmarksTooltip = ({
  title,
  customerBenchmark = 0,
  industryBenchmark = 0,
  open,
}: Props) => {
  return (
    <Tooltip disableHoverablePopup open={open}>
      <TooltipTrigger
        render={
          <div
            className="absolute inset-y-0 left-0"
            style={{
              width: numberFormat(customerBenchmark, { isPercent: true }),
            }}
          />
        }
      />
      <TooltipContent side="bottom" className="max-w-150">
        <MultiSeriesTooltip title={title}>
          <TooltipRow
            color={TAM_PRIMARY}
            name={t`Your Performance`}
            value={t`${numberFormat(customerBenchmark, {
              isPercent: true,
              precision: 0,
            })} TAM Traffic`}
          />
          <TooltipRow
            color={VISITS_PRIMARY}
            name={t`Industry Average`}
            value={t`${numberFormat(industryBenchmark, {
              isPercent: true,
              precision: 0,
            })} TAM Traffic`}
          />
        </MultiSeriesTooltip>
      </TooltipContent>
    </Tooltip>
  );
};

export default BenchmarksTooltip;
